import ACTION_TYPES from "./type.action";

export const setShowAssessmentRollbackPopup = (toShow) => {
  return { type: ACTION_TYPES.SET_SHOW_ASSESSMENT_ROLLBACK, payload: toShow };
};
